<div id="home-content">
  <app-accroche id="accorche" />
  <app-presentation-prestations id="prestations" />

  <div id="agenda">
    <h3>L’agenda : ne manquez pas nos prochains événements !</h3>
    <app-agenda></app-agenda>
  </div>

  <div id="newsletter">
    <h3>La newsletter mensuelle : l’actualité nature murmurée chaque dernier mercredi du mois</h3>
    <p>Une petite note avec le détail de nos prochaines animations, mais aussi des pistes et outils pour explorer la
      nature avec les enfants. Une invitation à s’émerveiller du Vivant avec les enfants… et à ne rien louper de notre
      actualité !</p>
    <p>Les murmures du mois” sont envoyés sur votre boîte mail tous les derniers mercredis du mois, à 18h00.</p>
    <button>S’inscrire à la newsletter “Les Murmures du mois” 💌</button>
  </div>
</div>